import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Dashboard/Dashboard.css'

import CustomTable from '@/product/components/molecules/CustomTable'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CartContext from '@/product/context/cart/cartContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import InvoiceView from './view'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'
import { useHistory } from 'react-router-dom'
import {
    handleRedirectInternal,
    mapData,
    dateFormatFunction,
} from '@/product/common/components'
import AlertContext from '@/product/context/alert/alertContext'

const Invoice = (props) => {
    const history = useHistory()

    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const reportContext = useContext(ReportContext)
    const [isLoading, setIsLoading] = useState(true)
    const { getAllExportDownload, getAllReportDownload } = reportContext
    const { allAgencies } = customCommonContext

    const {
        all_invoices,
        getAllInvoices,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const { responseStatus: responseStatusCart } = cartContext
    const { user } = authContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const [changeStatus, setChangeStatus] = React.useState(false)
    const [invoiceNotesStatus, setInvoiceNotesStatus] = React.useState(false)
    const [filteredAgencies, setFilteredAgencies] = useState([])
    const [dailyDepositPopUp, setDailyDepositPopUp] = useState(false)
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageCredits, setManageCredits] = useState({
        popup: false,
        status: 'new',
        data: null,
        id: 0,
        sid: 0,
    })

    const [manageRefund, setManageRefund] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup) {
            setManage({ popup, status, id, sid })
        } else {
            setManage({ popup, status: status ? status : 'new', id: 0, sid: 0 })
        }
    }

    const toggleCreditsPopup = (popup, status, data) => {
        if (popup) {
            setManageCredits({ popup, status, data })
        } else {
            setManageCredits({ popup, status: 'new', data: null })
        }
    }

    const toggleRefundPopup = (popup, status, data) => {
        if (popup) {
            setManageRefund({ popup, status, data })
        } else {
            setManageRefund({ popup, status: 'new', data: null })
        }
    }

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const toggleInvoiceModal = () => {
        setInvoiceNotesStatus(!invoiceNotesStatus)
    }

    let action = 'paid'

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            groupby: ' group by p.id ',

            filters: {
                action: {
                    value: action ? action.toString() : null,
                    type: 'in',
                    field: 'b.paid',
                },
                active: {
                    value: 2,
                    type: 'in',
                    field: 'b.active',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                projects_title: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                pay_received: {
                    value: '',
                    type: 'in',
                    field: 'b.pay_received',
                },
                // custom_projects_model_no: {
                //     value: '',
                //     type: 'like',
                //     field: 'it.model_no',
                // },
                // custom_projects_manufacturer: {
                //     value: '',
                //     type: 'like',
                //     field: 'it.manufacturer',
                // },
                projects_date_closed: {
                    value: '',
                    type: 'like',
                    field: 'p.date_closed',
                },
                order_due_date: {
                    value: '',
                    type: 'like',
                    field: 'b.order_due_date',
                },
                agency_id: {
                    value:
                        user?.emp_type == 'agency'
                            ? user?.emp_agencies?.split(',')[0]
                            : '',
                    type: 'in',
                    field: 'p.agency_id',
                },
                agency_ids: {
                    value: [],
                    type: 'findinarray',
                    field: 'p.agency_id',
                },
                paidfromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'b.paid_date',
                },
                paidtodate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'b.paid_date',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'p.date_closed',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'p.date_closed',
                },
                manufacturer: {
                    value: '',
                    type: 'in',
                    field: 'it.manufacturer',
                },
                model_no: {
                    value: '',
                    type: 'in',
                    field: 'it.model_no',
                },
                year: {
                    value: '',
                    type: 'in',
                    field: 'it.year',
                },
            },
        },

        onSubmit: (values) => {
            setIsLoading(true)
            getAllInvoices(values)
        },
    })
    const closeDailyDeposit = () => {
        setDailyDepositPopUp(!dailyDepositPopUp)
        if (formik.values && formik.values?.filters?.agency_ids) {
            formik.values.filters.agency_ids.value = []
        }
    }
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            notes: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().when('action', {
                is: 'cancel',
                then: Yup.string().required('Required!'),
            }),
        }),
        onSubmit: (values) => {
            if (
                values.action === 'paid' ||
                values.action === 'draft' ||
                values.action === 'cancel'
            ) {
                changeProductStatus(values)
            } else if (values.action === 'pay_received') {
                changeProductStatus(values)
            } else {
                assignAuctionLot(values)
            }
        },
    })

    const formikNotesSelection = useFormik({
        initialValues: {
            invoice_notes: '',
        },
        validationSchema: Yup.object({
            invoice_notes: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {
            console.log(values, 'checkValues')
        },
    })

    useEffect(() => {
        if (all_invoices) {
            setTableBody(
                all_invoices.records.length ? all_invoices.records : []
            )
            setIsLoading(false)
        }
    }, [all_invoices])

    useEffect(() => {
        if (user?.emp_type && user.emp_type === 'agency') {
            if (allAgencies && allAgencies.length) {
                if (user && user.emp_agencies) {
                    let filteredPreAgencies = allAgencies
                        .filter((d) => {
                            return user.emp_agencies
                                .toString()
                                .split(',')
                                .includes(d.id.toString())
                        })
                        .map((subcat) => {
                            let subCategoryChanged = {}
                            subCategoryChanged.show = subcat.agency_name
                            subCategoryChanged.value = subcat.id
                            return subCategoryChanged
                        })

                    setFilteredAgencies(filteredPreAgencies)
                }
            }
        } else {
            if (allAgencies && allAgencies.length) {
                let filteredPreAgencies = allAgencies.map((subcat) => {
                    let subCategoryChanged = {}
                    subCategoryChanged.show = subcat.agency_name
                    subCategoryChanged.value = subcat.id
                    return subCategoryChanged
                })

                setFilteredAgencies(filteredPreAgencies)
            }
        }
    }, [allAgencies, user])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.projects_title.value = ''
        formik.values.filters.pay_received.value = ''

        // formik.values.filters.custom_projects_manufacturer.value = ''
        // formik.values.filters.custom_projects_model_no.value = ''
        formik.values.filters.projects_date_closed.value = ''
        formik.values.filters.searchterm.value = ''
        if (action === 'all') {
            formik.values.filters.active.type = 'all'
        } else {
            formik.values.filters.active.type =
                action === 'cancel' ? 'in' : 'notin'
            formik.values.filters.active.value = 2
        }

        if (action === 'cancel') {
            formik.values.groupby = ''
        }

        getAllInvoices(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (manage.status === 'refresh') {
            getAllInvoices(formik.values)
        }
    }, [manage])

    useEffect(() => {
        console.log('formikSelection.values', formikSelection.values)
    }, [formikSelection.values])

    const onClickView = (id, sid, type) => {
        // toggleFullScreenPopup(true, type, id, sid)
        handleRedirectInternal(history, `invoice/view/${id}/${sid}`)
    }

    const onEditNotes = () => {
        toggleInvoiceModal(true)
    }

    const onClickEdit = (id, secondaryID, type) => {
        let selectItem = null
        tableBody.map((item) => {
            if (item.common_invoice === id) {
                selectItem = item
            }
        })
        toggleCreditsPopup(true, type, selectItem)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.project_id = data
        if (
            action === 'paid' ||
            action === 'draft' ||
            action === 'cancel' ||
            action === 'pay_received'
        ) {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'view',
                onclick: onClickView,
                tooltipTitle: 'View invoice',
            },
            // {
            //     buttonType: 'description',
            //     clickType: 'view',
            //     onclick: onEditNotes,
            //     tooltipTitle: 'Add invoice notes',
            // },
        ]
        // if (action === 'unpaid' || action === 'draft') {
        //     actionPush.push({
        //         buttonType: 'monetization_on',
        //         clickType: 'edit',
        //         onclick: onClickEdit,
        //         tooltipTitle: 'Make payment',
        //     })
        // }
        // if (action === 'paid') {
        //     actionPush.push({
        //         buttonType: 'undo',
        //         clickType: 'edit',
        //         onclick: onClickRefundInvoice,
        //         tooltipTitle: 'Refund Invoice',
        //         clickID: 'common_invoice',
        //         secondaryClickID: 'user_id',
        //     })
        // }
        return actionPush
    }

    const onClickProduct = (id, secondaryID, type) => {
        // handleRedirectInternal(history, `listing/edit/${id}`)
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${secondaryID}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    const onClickRefundInvoice = (id, secondaryID) => {
        toggleRefundPopup(true, 'view', {
            id,
            user_id: secondaryID,
            projects_shipping: 'shipEngine',
        })
    }

    const tableValues = [
        {
            field: 'common_invoice',
            type: 'hyperlink',
            clickID: 'common_invoice',
            secondaryClickID: 'user_id',
            clickType: 'view',
            onclick: onClickView,
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            filterable: true,
            filterField: 'b.common_invoice',
        },
        {
            field: 'agencies_agency_name',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Agency Name',
            filterable: true,
            filterField: 'ag.agency_name',
        },
        {
            field: 'projects_id',
            type: 'number',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Inventory #',
            filterable: true,
            filterField: 'p.id',
        },
        {
            field: 'projects_title',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickProduct,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Inventory Title',
            filterable: true,
            filterField: 'p.title',
            secondaryClickID: 'projects_id',
        },
        {
            field: 'projects_date_closed',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Sale Date',
            filterable: true,
            filterField: 'p.date_closed',
        },
        {
            field: 'custom_projects_unit_no',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Unit #',
            filterable: true,
            filterField: 'it.unit_no',
        },
        {
            field: 'custom_projects_mileage',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Mileage ',
            filterable: true,
            filterField: 'it.mileage',
        },
        {
            field: 'custom_projects_serial_no',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Serial Number',
            filterable: true,
            filterField: 'it.serial_no',
        },
        {
            field: 'custom_projects_manufacturer',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Manufacturer',
            filterable: true,
            filterField: 'it.manufacturer',
        },
        {
            field: 'custom_projects_model_no',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Model No.',
            filterable: true,
            filterField: 'it.model_no',
        },
        {
            field: 'custom_projects_year',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Year',
            filterable: true,
            filterField: 'it.year',
        },
        {
            field: 'paid_amount',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Paid Amount',
            filterable: true,
            filterField: 'b.paid_amount',
        },
        // {
        //     field: 'projects_date_closed',
        //     type: 'date',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Order Date',
        //     filterable: true,
        //     filterField: 'p.date_closed',
        // },
        // {
        //     field: 'seller_commission_percent',
        //     type: 'percentage',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Seller Commission percent',
        //     filterable: true,
        //     filterField: 'b.seller_commission_percent',
        // },
        {
            field: 'total_invoice_commission',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Seller Commission Fee',
            filterable: true,
            filterField: 'b.total_invoice_commission',
        },
        {
            field: 'seller_balance_amount',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Balance Amount',
            filterable: true,
            filterField: 'b.seller_balance_amount',
        },
    ]

    tableValues.push(
        {
            field: 'users_first_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User First Name',
            filterable: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_last_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Last Name',
            filterable: true,
            filterField: 'u.last_name',
        },
        {
            field: 'users_companyname',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Company',
            filterable: true,
            filterField: 'u.companyname',
        },
        {
            field: 'users_email',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Email',
            filterable: true,
            filterField: 'u.email',
        }
    )

    if (action === 'paid') {
        tableValues.push({
            field: 'paid_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Paid Date',
            filterable: true,
            filterField: 'b.paid_date',
        })
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'common_invoice',
        secondaryClickID: 'user_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const tableActions = []

    if (action === 'paid') {
        // tableActions.push({
        //     label: 'Move to Unpaid',
        //     icon: <span className="material-icons">low_priority</span>,
        //     onclick: onSelectMultiProducts,
        //     type: 'draft',
        // })
    } else if (action === 'unpaid' || action === 'draft') {
        // tableActions.push({
        //     label: 'Payment Received',
        //     icon: <span className="material-icons">low_priority</span>,
        //     onclick: onSelectMultiProducts,
        //     type: 'paid',
        // })
        if (user?.emp_type !== 'agency') {
            tableActions.push({
                label: 'Mark as Payment Received',
                icon: <span className="material-icons">price_check</span>,
                onclick: onSelectMultiProducts,
                type: 'pay_received',
            })
            tableActions.push({
                label: 'Cancel Invoice',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'cancel',
            })
        }
    } else {
        if (user?.emp_type !== 'agency') {
            tableActions.push(
                {
                    label: 'Move to Unpaid',
                    icon: <span className="material-icons">low_priority</span>,
                    onclick: onSelectMultiProducts,
                    type: 'draft',
                },
                {
                    label: 'Move to Paid',
                    icon: <span className="material-icons">low_priority</span>,
                    onclick: onSelectMultiProducts,
                    type: 'paid',
                }
            )
        }
    }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Title',
                placeholder: 'Enter title',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'projects_title',
                filter: true,
            },
            {
                label: 'Payment Status',
                placeholder: 'Select Payment Status',
                class: `${action === 'unpaid' ? '' : 'd-none'} col-sm-4 col-12`,
                type: 'select',
                name: 'pay_received',
                options: [
                    { value: 1, show: 'Received' },
                    { value: '0', show: 'Not Received' },
                ],
                filter: true,
                native: true,
            },
            // {
            //     label: 'Manufacturer',
            //     placeholder: 'Enter Manufacturer',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'custom_projects_manufacturer',
            //     filter: true,
            // },
            // {
            //     label: 'Model No',
            //     placeholder: 'Enter Model No',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'custom_projects_model_no',
            //     filter: true,
            // },
            {
                label: 'Status',
                placeholder: 'Select Status',
                class: `${action === 'all' ? '' : 'd-none'} col-sm-4 col-12`,
                type: 'select',
                options: [
                    {
                        show: 'Paid',
                        value: 'paid',
                    },
                    {
                        show: 'Unpaid',
                        value: 'unpaid',
                    },
                    {
                        show: 'Partially Paid',
                        value: 'draft',
                    },
                    {
                        show: 'Archive',
                        value: 'cancel',
                    },
                ],
                name: 'action',
                filter: true,
            },

            {
                label: 'Paid From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'paidfromdate',
                filter: true,
            },
            {
                label: 'Paid To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'paidtodate',
                filter: true,
            },
            {
                label: 'Sale From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Sale To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
            {
                label: 'Manufacturer',
                placeholder: 'Enter Manufacturer',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'manufacturer',
                filter: true,
            },
            {
                label: 'Model',
                placeholder: 'Enter Model',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'model_no',
                filter: true,
            },
            {
                label: 'Year',
                placeholder: 'Enter Year',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'number',
                name: 'year',
                filter: true,
            },
            {
                label: 'Agency',
                type: 'autocomplete',
                placeholder: 'Select Agency',
                class: `col-sm-auto col-12 ${
                    user?.emp_type && user.emp_type === 'agency' ? '' : 'd-none'
                }`,
                name: 'agency_id',
                filter: true,
                multiple: true,
                size: 'small',
                options: filteredAgencies,
            },
        ],
    }
    const agencyFilter = {
        formik: formik,
        data: [
            {
                label: 'Agency',
                type: 'autocomplete',
                placeholder: 'Select Agency',
                class: `col-md-4 col-sm-6 col-12 `,
                name: 'agency_ids',
                filter: true,
                multiple: true,
                options: filteredAgencies,
            },
        ],
    }
    const reasonForCancelInvoice = [
        {
            label: 'Reason *',
            name: 'notes',
            type: 'text',
            placeholder: 'Reason for cancellation',
            formik: formikSelection,
        },
    ]

    const invoiceNotes = [
        {
            label: 'Notes',
            name: 'invoice_notes',
            type: 'textarea',
            placeholder: 'Enter your invoice notes',
            formik: formikNotesSelection,
        },
    ]

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                setAlert(
                    responseStatusInvoice.message,
                    responseStatusInvoice.status
                )
                setChangeStatus(false)
                getAllInvoices(formik.values)
            }
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        if (responseStatusCart) {
            if (responseStatusCart.status === 'success') {
                if (responseStatusCart.from === 'payCartWallet') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                } else if (responseStatusCart.from === 'payCartOffline') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                }
            }
        }
    }, [responseStatusCart])
    const downLoadDeposit = () => {
        const payload = {
            action: 'download',
            order: 'asc',
            orderby: '',
            search: 'customSelection',
            report: 'auction_seller_recap_reports',
            within: 'day',
            // page: 1,
            // limit: 2000,
            limit_results: '',
            searchterm: '',
            fields: [
                'id',
                'title',
                'winnerName',
                'buynowemail',
                'common_invoice',
                'date_added',
                'seller_name',
                'amount',
                'total_commission',
                'seller_balance_amount',
                'total_amount',
                'paid_amount',
                'agency_name',
                'acc_num',
                'funds',
                'approp',
                'pc_bus',
                'project_type',
                'src_type',
                'notes',
                'vendor_id',
                'county_tax',
                'city_tax',
                'county_transit_sales_use_tax',
                'metro_transportation_tax',
                'metro_sale_use_for_housing',
                'transit_tax',
                'vehicle_tax',
                'auto_excise_tax',
            ],
            report_name: 'Daily Deposit',
            filters: {
                agency_id: {
                    value: formik.values?.filters?.agency_ids?.value
                        ? formik.values?.filters?.agency_ids?.value
                        : [],
                    type: 'findinarray',
                    field: 'p.agency_id',
                },
            },
            single_date: dateFormatFunction(new Date()),
            select_type: 'single_date',
        }
        getAllReportDownload(payload)
        closeDailyDeposit()
    }
    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="miscActions d-flex justify-content-end align-items-center mt-4 flex-wrap">
                    <div className="d-flex ">
                        <Button
                            id="invoice_report"
                            onClick={() => setDailyDepositPopUp(true)}
                        >
                            <span className="material-icons">get_app</span>
                            Daily Deposit Download
                        </Button>
                        <Button
                            id="invoice_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'desc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_invoice_management`,
                                    isDefault: null,
                                    custom_groupby: 'group by p.id',
                                    fields:
                                        [...tableValues].filter(
                                            (each) => each.field !== 'action'
                                        ) || [],
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_invoices}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllInvoices}
                    columnStorageVariable={'table_agency_payment_manage'}
                />
            </div>
            {/* <InvoiceView
                data={manage}
                action={action}
                function={toggleFullScreenPopup}
            /> */}

            <CustomDialog
                title={'Change invoice status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                {formikSelection.values.action === 'cancel' &&
                    mapData(reasonForCancelInvoice)}
                <div className="actionWrapper">
                    <Button
                        id="invoice_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="invoice_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title="Invoice notes"
                open={invoiceNotesStatus}
                className="invoiceNotes"
                function={toggleInvoiceModal}
            >
                <h5>Add any specific information related to invoices here.</h5>
                {mapData(invoiceNotes)}
                <div className="actionWrapper">
                    <Button onClick={() => toggleInvoiceModal()}>Cancel</Button>
                    <form
                        onSubmit={formikNotesSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Choose Agency for Download Deposit Details'}
                open={dailyDepositPopUp}
                function={closeDailyDeposit}
            >
                <h5>Please Select Agency</h5>

                {dailyDepositPopUp && mapData(agencyFilter)}
                <div className="actionWrapper">
                    <Button id="invoice_cancel" onClick={closeDailyDeposit}>
                        Cancel
                    </Button>
                    {/* <form onSubmit={downLoadDeposit} autoComplete="nofill"> */}
                    {(formik.values?.filters?.agency_ids?.value &&
                        formik.values?.filters?.agency_ids?.value.length) ||
                    (user && user?.emp_type && user.emp_type !== 'agency') ? (
                        <PrimaryButton
                            id="invoice_confirm"
                            type="submit"
                            label="Download Report"
                            onClick={() => {
                                downLoadDeposit()
                            }}
                        />
                    ) : null}

                    {/* </form> */}
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default Invoice
